import { apiRequest } from "./apiUtils";

/**
 * 枚举选项接口
 */
export interface EnumOption {
  value: number;
  label: string;
}

/**
 * 枚举服务类
 * 无需认证即可访问
 */
class EnumService {
  /**
   * 获取性别枚举选项
   */
  async getGenderOptions(): Promise<EnumOption[]> {
    const response = await apiRequest<{ data: EnumOption[] }>(
      "/api/v1/enums/gender-options",
      "GET"
    );
    return response.data;
  }

  /**
   * 获取长者身份枚举选项
   */
  async getElderIdentityOptions(): Promise<EnumOption[]> {
    const response = await apiRequest<{ data: EnumOption[] }>(
      "/api/v1/enums/elder-identity-options",
      "GET"
    );
    return response.data;
  }
}

export const enumService = new EnumService();
